<form class="d-flex flex-column" [formGroup]="form">
    <div class="d-flex align-items-center justify-content-center">
        <input
            class="form-control"
            [ngClass]="{ 'input-error': isError }"
            ngbAutofocus
            #digit1Input
            type="text"
            formControlName="digit1"
            (keydown)="onKeyDown($event, 'digit2Input')"
            inputmode="numeric"
            mask="9"
            maxlength="1"
        />
        <input
            [ngClass]="{ 'input-error': isError }"
            #digit2Input
            type="text"
            formControlName="digit2"
            (keydown)="onKeyDown($event, 'digit3Input')"
            inputmode="numeric"
            mask="9"
            maxlength="1"
        />
        <input
            [ngClass]="{ 'input-error': isError }"
            #digit3Input
            type="text"
            formControlName="digit3"
            (keydown)="onKeyDown($event, 'digit4Input')"
            inputmode="numeric"
            mask="9"
            maxlength="1"
        />
        <input
            [ngClass]="{ 'input-error': isError }"
            #digit4Input
            type="text"
            formControlName="digit4"
            inputmode="numeric"
            mask="9"
            maxlength="1"
        />
    </div>
</form>
